var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 2.1875L5.1875 4.90625C6.59375 3.84375 8.34375 3 10.5 3C13 3 15.0312 4.15625 16.5 5.53125C17.9688 6.875 18.9375 8.5 19.4062 9.625C19.5 9.875 19.5 10.1562 19.4062 10.4062C19 11.4062 18.1562 12.8438 16.9062 14.0938L20.1875 16.6875C20.5312 16.9375 20.5938 17.4062 20.3125 17.7188C20.0625 18.0625 19.5938 18.125 19.2812 17.8438L0.78125 3.34375C0.4375 3.09375 0.375 2.625 0.65625 2.3125C0.90625 1.96875 1.375 1.90625 1.6875 2.1875ZM7.46875 6.6875L10.2812 8.90625C10.4062 8.625 10.5 8.34375 10.5 8.03125C10.5 7.78125 10.4375 7.59375 10.375 7.375C10.3438 7.21875 10.4375 7 10.625 7.03125C11.9062 7.0625 13.0312 7.9375 13.375 9.25C13.5625 9.9375 13.5 10.625 13.25 11.2188L14.4375 12.1562C14.7812 11.5312 15 10.7812 15 10C15 7.53125 12.9688 5.5 10.5 5.5C9.3125 5.5 8.25 5.96875 7.46875 6.6875ZM12.1562 14.1875L14.4375 16C13.2812 16.625 11.9688 17 10.5 17C7.96875 17 5.9375 15.875 4.46875 14.5C3 13.125 2.03125 11.5 1.5625 10.4062C1.46875 10.1562 1.46875 9.875 1.5625 9.625C1.875 8.90625 2.375 8 3.09375 7.0625L6.03125 9.375C6 9.59375 6 9.8125 6 10C6 12.5 8 14.5 10.5 14.5C11.0625 14.5 11.625 14.4062 12.1562 14.1875Z",
    fill: "url(#paint0_linear_3780_56376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_56376",
    x1: 2,
    y1: 2,
    x2: 17.5,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#0D0C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeSlash);
export default __webpack_public_path__ + "static/media/icon-eye-slash.d7b76a92c5c93eb18fd1f93178c84c2d.svg";
export { ForwardRef as ReactComponent };